export default __webpack_public_path__ + "static/media/pic5.21d1faac.jpg";